import React from "react";
import ActivityMessage           from "./custom/ActivityMessage";
import StrategyMessage           from "./custom/StrategyMessage";
import TradeMessage              from "./custom/TradeMessage";
import CommunityStrategyMessage  from "./custom/CommunityStrategyMessage";
import CommunityActivityMessage  from "./custom/CommunityActivityMessage";
import RedPacketPreviewMessage   from "./custom/RedPacketPreviewMessage";
import RedPacketMessage          from "./custom/RedPacketMessage";
import AnnouncementMessage       from "./custom/AnnouncementMessage";
import GreatGamesMessage          from "./custom/GreatGamesMessage";
import HolidaysMessage          from "./custom/HolidaysMessage";

// subType → 组件映射表。新增自定义消息类型只需：
//   1. 在 custom/ 目录下新建文件（继承 CustomCardBase 或独立布局）
//   2. 在此处注册一行
const CUSTOM_TYPE_MAP = {
  1: ActivityMessage,
  2: StrategyMessage,
  3: TradeMessage,
  4: CommunityStrategyMessage,
  5: CommunityActivityMessage,
  6: RedPacketPreviewMessage,
  7: RedPacketMessage,
  9: AnnouncementMessage,
  10: GreatGamesMessage,
  11: HolidaysMessage
};

export default function CustomMessage({ msg }) {
  const Component = CUSTOM_TYPE_MAP[msg.subType];
  return Component ? <Component msg={msg} /> : null;
}
